import { Injectable } from '@angular/core';
import { AssetLibraryConstants } from './constants/asset-library.constant';
import { map } from 'rxjs/internal/operators/map';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { GlobalConstants } from './../../../../common/constants/global.constant';

@Injectable({
  providedIn: 'root'
})
export class SendToStoreService {

  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  retailerId = sessionStorage.getItem(GlobalConstants.RETAILERID);
  SEND_TO_STORE_URL = AssetLibraryConstants.ASSET_LIBRARY_USERS + this.userId
  + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId;
  constructor(private httpMethodsservice: HttpMethodsService) { }

  sendToStoreService(segmentId: string, data) {
    const url = this.SEND_TO_STORE_URL + AssetLibraryConstants.SEGMENTS + AssetLibraryConstants.SLASH + segmentId +
    AssetLibraryConstants.SLASH + AssetLibraryConstants.SEND_TO_RETAILER_ID + this.retailerId;

    return this.sendApiCall(url, data);
  }

  sendApiCall(url, data) {
    return this.httpMethodsservice.patch(url, JSON.stringify(data))
      .pipe(map((res: any) =>
        res));
  }

  sendLogoToStoreService(logoContentId: string, data) {
    const url = this.SEND_TO_STORE_URL + AssetLibraryConstants.LOGO_CONTENTS + AssetLibraryConstants.SLASH + logoContentId +
    AssetLibraryConstants.SLASH + AssetLibraryConstants.SEND_TO_RETAILER_ID + this.retailerId;
    
    return this.sendApiCall(url, data);
  }

  sendPromoToStoreService(promoContentId: string, data) {
    const url = this.SEND_TO_STORE_URL + AssetLibraryConstants.PROMO_CONTENTS + AssetLibraryConstants.SLASH + promoContentId +
    AssetLibraryConstants.SLASH + AssetLibraryConstants.SEND_TO_RETAILER_ID + this.retailerId;
    
    return this.sendApiCall(url, data);
  }
  sendPriceToStoreService(priceContentId: string, data) {
    const url = this.SEND_TO_STORE_URL + AssetLibraryConstants.PRICE_CONTENTS + AssetLibraryConstants.SLASH + priceContentId +
    AssetLibraryConstants.SLASH + AssetLibraryConstants.SEND_TO_RETAILER_ID + this.retailerId;
    
    return this.sendApiCall(url, data);
  }

  sendStoreLogoService(storeLogoId: string, data) {
    const url = this.SEND_TO_STORE_URL + AssetLibraryConstants.STORE_LOGO
    + AssetLibraryConstants.SLASH + storeLogoId +
    AssetLibraryConstants.SLASH + AssetLibraryConstants.SEND_TO_RETAILER_ID + this.retailerId;
    
    return this.sendApiCall(url, data);
  }
  
  sendBannerToStoreService(bannerCarouselId: string, data) {
    const url = this.SEND_TO_STORE_URL + AssetLibraryConstants.BANNER_CONTENTS + AssetLibraryConstants.SLASH + bannerCarouselId +
    AssetLibraryConstants.SLASH + AssetLibraryConstants.SEND_TO_RETAILER_ID + this.retailerId;

    return this.sendApiCall(url, data);
  }

  sendHeroTileToStoreService(heroTileId: string, data) {
    const url = this.SEND_TO_STORE_URL + AssetLibraryConstants.CUSTOM_HEROTILES + AssetLibraryConstants.SLASH +  heroTileId + AssetLibraryConstants.SLASH + AssetLibraryConstants.SEND_TO_RETAILER_ID + this.retailerId;
    return this.sendApiCall(url, data);
  }
}
